import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

// Define props type, including children
type Props = {
  children?: React.ReactNode; // Make children optional as Outlet handles rendering
};

// Accept props even if children isn't directly used
export const SuperAdminRoute = (props: Props) => {
  const { user, loading, profile } = useAuth();

  // Wait for both initial loading AND profile data
  if (loading || !profile) { 
    // If still loading OR profile hasn't been fetched yet, show spinner
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // At this point, loading is false AND profile exists

  if (!user) {
    // Should ideally not be reached if loading is false & profile exists, but safe check
    return <Navigate to="/login" replace />;
  }

  if (profile.role !== 'superadmin') { // Can safely access profile.role now
    // User is logged in but not a superadmin
    console.warn('Access denied: User profile role is not superadmin.', profile);
    return <Navigate to="/dashboard" replace />;
  }

  // User is logged in and is a superadmin, render the children passed to the component
  return <>{props.children}</>; // CORRECT: Render the wrapped component
}; 